import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3356da50")

_pushScopeId("data-v-3356da50")
const _hoisted_1 = { class: "main__section" }
const _hoisted_2 = { class: "view-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "-bold" }, "신청 상세정보", -1)
const _hoisted_4 = {
  key: 0,
  class: "request-view view-card"
}
const _hoisted_5 = { class: "view-card__header" }
const _hoisted_6 = { class: "view-card__header__top" }
const _hoisted_7 = { class: "status" }
const _hoisted_8 = { class: "insertDate -notosans" }
const _hoisted_9 = {
  key: 0,
  class: "view-card__header__mid"
}
const _hoisted_10 = { class: "doctor-item-detail" }
const _hoisted_11 = { class: "-medium" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "-medium" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "label" }, "유형", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = {
  key: 0,
  class: "-medium -pc"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "label -notosans" }, "예약일시", -1)
const _hoisted_19 = { class: "value" }
const _hoisted_20 = {
  key: 0,
  class: "-medium -mobile scheduled-date"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "label" }, "예약일시", -1)
const _hoisted_22 = { class: "value -notosans" }
const _hoisted_23 = { class: "view-card__header__bot" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_25 = { class: "view-card__body" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "label" }, "예약 코멘트", -1)
const _hoisted_28 = { class: "value" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "label" }, "주증상", -1)
const _hoisted_30 = { class: "value" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "label" }, "파일첨부", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RequestProgressDesc = _resolveComponent("RequestProgressDesc")
  const _component_RequestProgress = _resolveComponent("RequestProgress")
  const _component_DoctorItem = _resolveComponent("DoctorItem")
  const _component_router_link = _resolveComponent("router-link")
  const _component_FileList = _resolveComponent("FileList")

  return (_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_RequestProgressDesc, {
          cardInfo: _ctx.cardInfo,
          class: "-mobile"
        }, null, 8, ["cardInfo"])
      ]),
      (!_ctx.state.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_RequestProgress, { cardInfo: _ctx.cardInfo }, null, 8, ["cardInfo"]),
                  _createVNode(_component_RequestProgressDesc, {
                    cardInfo: _ctx.cardInfo,
                    class: "-pc"
                  }, null, 8, ["cardInfo"])
                ]),
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.insertDateTime), 1)
              ]),
              (!!_ctx.state.doctor.DoctorKey)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode(_component_DoctorItem, {
                      doctor: _ctx.state.doctor,
                      isDetail: false
                    }, {
                      detail: _withId(() => [
                        _createVNode("div", _hoisted_10, [
                          _createVNode("ul", null, [
                            _createVNode("li", _hoisted_11, [
                              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.state.doctor.DeptName), 1),
                              _createVNode("span", _hoisted_13, _toDisplayString(_ctx.state.doctor.DoctorName), 1)
                            ]),
                            _createVNode("li", _hoisted_14, [
                              _hoisted_15,
                              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.requestKind), 1)
                            ]),
                            (_ctx.state.kind === _ctx.RequestKindTypes.OnlineCare)
                              ? (_openBlock(), _createBlock("li", _hoisted_17, [
                                  _hoisted_18,
                                  _createVNode("span", _hoisted_19, _toDisplayString(_ctx.scheduledDate), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["doctor"]),
                    (_ctx.state.kind === _ctx.RequestKindTypes.OnlineCare)
                      ? (_openBlock(), _createBlock("div", _hoisted_20, [
                          _createVNode("div", null, [
                            _hoisted_21,
                            _createVNode("span", _hoisted_22, _toDisplayString(_ctx.scheduledDate), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_23, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cardInfo.buttons, (b, index) => {
                  return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                    (b.type === 'link')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: ["-button", b.style],
                          to: b.path()
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(b.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"]))
                      : _createCommentVNode("", true),
                    (b.type === 'button')
                      ? (_openBlock(), _createBlock("button", {
                          key: 1,
                          class: ["-button", b.style],
                          onClick: b.path
                        }, _toDisplayString(b.label), 11, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _hoisted_24,
            _createVNode("div", _hoisted_25, [
              _createVNode("ul", null, [
                (
                !!_ctx.state.item.OtherComments &&
                _ctx.state.item.RequestStatus > _ctx.RequestStatuses.Requested
              )
                  ? (_openBlock(), _createBlock("li", _hoisted_26, [
                      _hoisted_27,
                      _createVNode("span", _hoisted_28, _toDisplayString(_ctx.state.item.OtherComments), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("li", null, [
                  _hoisted_29,
                  _createVNode("span", _hoisted_30, _toDisplayString(_ctx.state.purpose.other), 1)
                ]),
                _createVNode("li", null, [
                  _hoisted_31,
                  (_ctx.state.purpose.files && _ctx.state.purpose.files.length > 0)
                    ? (_openBlock(), _createBlock(_component_FileList, {
                        key: 0,
                        class: "upload-files",
                        list: _ctx.state.purpose.files,
                        onDeletedFile: _ctx.deletedFile,
                        id: _ctx.state.id,
                        requestKind: _ctx.state.kind
                      }, null, 8, ["list", "onDeletedFile", "id", "requestKind"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})